import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import AppContext from "../context/AppContext";
import { readCache } from "../modules/tsp/hooks/useTspPermission";
//http://localhost:3000/dashboard?link=12345
const ProtectedRoute = ({ children }) => {
  const search = useLocation().search;
  const router = useLocation();
  const link_id = new URLSearchParams(search).get("link");
  const { token, user } = React.useContext(AppContext);

  if (token && router.pathname == "/login") {
    const cached = readCache(token);
    const userHasTspFlag =
      user?.has_tsp_access === true ||
      user?.has_tsp_access === 1 ||
      user?.has_tsp_access === "1" ||
      user?.has_tsp_access === "true";
    const userHasTspRole = typeof user?.role === "string" && user.role.toLowerCase().includes("tsp");
    const isTsp = Boolean(userHasTspFlag || userHasTspRole || cached?.hasTspAccess || (cached?.role && cached?.permissions?.length > 0));
    return <Navigate to={isTsp ? "/tsp" : "/"} />;
  }

  if (
    user != null &&
    (user.role == "GBC (Governing Body Commission)" || user.role == "Regional Zonal Secretary") &&
    (router.pathname == "/recording-pledge" || router.pathname == "/update-score" || router.pathname == "/view-history")
  ) {
    return <Navigate to="/" />;
  }

  return token ? children : <Navigate to={link_id ? "/login?link=" + link_id : "/login"} />;
};

export default ProtectedRoute;
